// extracted by mini-css-extract-plugin
export default {"color-grey-4":"#F5F4F2","colorGrey4":"#F5F4F2","iconWrapper":"_21NYs","ctaButton":"_1YSn5"};